<template>
  <section>
    <div class="list">
      <div class="tr tr_title">
        <span>Name (English)</span>
        <span>Name (Chinese)</span>
        <span>Actions</span>
      </div>
      <section ref="sortable">
        <div
          v-for="(val,i) in tagList"
          :key="i + val.name"
          class="tr">
          <span>{{val.name_language['en-US']}}</span>
          <span>{{val.name_language['zh-HK']}}</span>
          <span class="actions">
            <span
              @click="handlerEdit(val)" >
              <font-awesome-icon
                icon="pen"
                class="icon_pen"/>
            </span>
            <span
              @click="handlerDel(val)" >
              <font-awesome-icon
                icon="trash-alt"
                class="icon_del"/>
            </span>
            <span
              @mousedown="handleClick(val)"
              @mouseenter="handleMouseEnter"
              @mouseleave="handleMouseLeave"
            >
              <font-awesome-icon
                icon="grip-lines"
                class="icon_lines"/>
            </span>
          </span>
        </div>
      </section>
    </div>

    <tag-dialog
      ref="tag-dialog"
      :tagId="tag_id"
      :form="formData"
      @success="handleSuccess"></tag-dialog>
  </section>
</template>

<script>
import { getTagList, changeTag } from '@/api/news'
import Sortable from 'sortablejs'
import TagDialog from './components/dialog/tag-dialog.vue'
export default {
  name: 'TagList',
  components:{
    TagDialog
  },
  data () {
    return {
      tagList: [],
      formData: {
        name_en_us: '',
        name_zh_hk: '',
        tag_id: null
      },
      rules:{
        'name_en_us':[
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ],
        'name_zh_hk':[
          { required: true, message: this.$t('placeholder.input'), trigger: ['change', 'blur'] }
        ]
      },
      sortable: {},
      tag_id: -1,
    }
  },
  mounted(){
    this.network().getTagList()
    let el = this.$refs['sortable']
    this.createSort(el)
  },
  methods: {
    changeDialog(){
      this.$refs['tag-dialog'].changeDialog()
    },

    handlerEdit(row) {
      const { name_language, id } = row
      this.tag_id = id
      this.formData = {
        name_en_us: name_language['en-US'],
        name_zh_hk: name_language['zh-HK'],
        tag_id: id
      }
      this.$refs['tag-dialog'].changeDialog()
    },

    handlerDel(row) {
      this.$ConfirmBox({
        message: `Are you sure to delete this tag（ ${row.name_language['en-US']} | ${row.name_language['zh-HK']} ）?`
      }).then(() => {
        const { id } = row
        let params = {
          tag_id: id
        }
        this.network().changeTag('delete', params)
      })
    },
    handleMouseLeave() {
      // 鼠标进入图标控制拖拽开启
      this.sortable.option('disabled', true)
    },
    handleMouseEnter() {
      // 鼠标离开图标控制拖拽关闭
      this.sortable.option('disabled', false)
    },

    handleClick(val) {
      this.tag_id = val.id
    },

    sortEnd(e) {
      // 拖拽完成执行
      if(e.oldIndex != e.newIndex){
        let params = {
          tag_id: this.tag_id,
          old_index: e.oldIndex,
          new_index: e.newIndex
        }
        this.network().changeTag('put', params)
      }
    },

    createSort(el){
      this.sortable = new Sortable(el,{
        ghostClass: 'blue',
        disabled: true,
        onEnd: this.sortEnd
      })
    },

    handleSuccess(){
      this.network().getTagList()
    },

    network(){
      return {
        getTagList: async () => {
          const { data } = await getTagList()
          this.tagList = data
        },

        changeTag: async (method, params) => {
          const { data } = await changeTag(method, params)
          if(data.message == 'success'){
            if(method != 'put'){
              this.$message({
                type: 'success',
                message: 'Success'
              })
            }
            this.network().getTagList()
          }
        }
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.blue{
  background: #ecf5ff;
}
.form-item{
  padding-bottom: 16px !important;
  span{
    display: block;
    padding-bottom: 5px;
    font-size: 14px;
    color: #24292e;
    font-family: Inter;
    font-weight: 600;
    letter-spacing: 0;
    line-height: 17px;
  }
}
.list{
    background: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    background: white;
    .tr_title{
      font-weight: bold;
      color: #909399;
      background: #f6f8fa;
    }
    .tr{
      padding: 10px;
      height: 40px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      font-size: 14px;
      &>span{
        flex: 1;
        text-align: center;
      }
      .actions{
        span{
          margin-right: 20px;
          padding: 5px;
          cursor: pointer;
          .icon_pen{
            color: rgba(3, 102, 214, 1);
          }
          .icon_del{
            color: rgba(203, 36, 49, 1);
          }
          .icon_lines{
            color: rgba(209, 213, 218, 1);
          }
        }
      }
    }
    .tr+.tr{
      border-top: 1px solid #EAECEF;
    }
  }
.dialog-container {
  padding: 15px;
}
</style>
